<div class="wrapper">
  <div id="factor" #factor>
    <div class="tags" fxLayoutAlign="space-between center">
      <div id="factorNumber">
        <span> فاکتور </span>
        <span>{{ index + 1 }}/{{ totalOrders || 3 }}</span>
      </div>
      <div id="orderNumber">
        <span> شماره سفارش: </span>
        <span>{{ info.instance.id }}</span>
      </div>
      <div id="paymentNumber">
        <span> شماره سبد: </span>
        <span dir="ltr">{{ payment.factorNumber }}</span>
      </div>
    </div>
    <div
      class="info-blocks"
      fxLayout="column"
      fxLayout.gt-md="row"
      fxLayoutAlign="space-between stretch"
    >
      <div
        fxFlex="100"
        id="generalInfo"
        class="info-block"
        fxFlex.gt-md="48"
        fxLayout="column"
      >
        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">اندازه کاغذ</div>
          <div class="data" fxFlex="50">
            {{ info.size || "unknown" }}
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">نوع چاپ</div>
          <div class="data" fxFlex="50">{{ info.type }}</div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">یک رو / دو رو</div>
          <div class="data" fxFlex="50">
            {{ info.side }}
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">تعداد برگ</div>
          <div class="data" fxFlex="50">
            {{ info.totalPageNum }}
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">صحافی یا کاور</div>
          <div class="data" fxFlex="50">
            {{ info.binding }}
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">رنگ طلق</div>
          <div class="data" fxFlex="50">
            {{ info.talcColor || "---" }}
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="50">تعداد نسخه</div>
          <div class="data" fxFlex="50">
            {{ info.copies }}
          </div>
        </div>
      </div>
      <div
        fxFlex="100"
        id="pagesInfo"
        class="info-block"
        fxFlex.gt-md="48"
        fxLayout="column"
        fxLayoutAlign="space-evenly"
      >
        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title">رنگی</div>
          <div class="data" fxFlex="100">
            <section
              class="chips-wrapper"
              *ngIf="info && (info.ranges['c'] || []).length > 0"
            >
              <span class="factor-chip" *ngFor="let range of info.ranges['c']">
                {{ range }}
              </span>
            </section>
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title">نیمه رنگی</div>
          <div class="data" fxFlex="100">
            <section
              class="chips-wrapper"
              *ngIf="info && (info.ranges['hc'] || []).length > 0"
            >
              <span class="factor-chip" *ngFor="let range of info.ranges['hc']">
                {{ range }}
              </span>
            </section>
          </div>
        </div>

        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title">سیاه و سفید</div>
          <div class="data" fxFlex="100">
            <section
              class="chips-wrapper"
              *ngIf="info && (info.ranges['bw'] || []).length > 0"
            >
              <span class="factor-chip" *ngFor="let range of info.ranges['bw']">
                {{ range }}
              </span>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div
      class="info-blocks"
      id="descriptionBlocks"
      fxLayout="column"
      fxLayout.gt-md="row"
      fxLayoutAlign="space-between stretch"
    >
      <!-- Description -->

      <div
        fxFlex="100"
        id="description"
        class="info-block"
        fxFlex.gt-md="60"
        fxLayout="column"
      >
        <div
          class="block"
          id="descriptionBlock"
          fxLayout="row"
          style="height: 100%"
          fxLayoutAlign="space-between stretch"
        >
          <div class="title">توضیحات</div>
          <div class="data" fxFlex="100">
            {{ info.instance.moreDetails || "" }}
          </div>
        </div>
      </div>
      <div
        fxFlex="100"
        class="info-block"
        id="econamicInfo"
        fxFlex.gt-md="28"
        fxLayout="column"
        fxLayoutAlign="space-evenly"
      >
        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="30">تاریخ ثبت</div>
          <div class="data" fxFlex="70">
            {{ getDate() | jdate : "d mmm yyyy" | digitsEnToFa }}
          </div>
        </div>
        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="30">زمان ثبت</div>
          <div class="data" fxFlex="70">
            {{ getDate() | jdate : "h:M t" | digitsEnToFa }}
          </div>
        </div>
        <div class="block" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title" fxFlex="30">مبلغ</div>
          <div class="data" fxFlex="70">
            {{ info.instance.price | irc : "T" | digitsEnToFa }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button mat-stroked-button color="primary" (click)="download()">
      <span>دانلود</span>
      <jam-icon vertical-align="middle" name="download"></jam-icon>
    </button>
    <button mat-stroked-button color="accent" (click)="print()">
      <span>پرینت</span>
      <jam-icon vertical-align="middle" name="printer"></jam-icon>
    </button>
  </div>
</div>
